import { useEffect, useRef } from "react";

/**
 * Lädt Panel-Daten beim Mount und bei Filter-Änderungen (neue `load`-Identität)
 * regulär – also mit sichtbarem Ladezustand. Reine `refreshKey`-Bumps
 * (Realtime-Events, Aktionen in Nachbar-Panels) laden dagegen **still** nach,
 * damit der sichtbare Inhalt nicht durch einen Spinner ersetzt wird und der
 * Benutzer nicht aus der Seite „herausgerissen" wird.
 */
export function useRefreshKeyLoad(
  load: (options?: { silent?: boolean }) => void | Promise<void>,
  refreshKey: number,
): void {
  const lastKeyRef = useRef(refreshKey);
  useEffect(() => {
    const silent = lastKeyRef.current !== refreshKey;
    lastKeyRef.current = refreshKey;
    void load({ silent });
  }, [load, refreshKey]);
}
